import { APICore } from "./apiCore";

const api = new APICore();

const getProfissionaisEnvolvidos = (paciente_id: string) => {
    return api.get(`/profissionais-envolvidos/${paciente_id}`);
};

export { getProfissionaisEnvolvidos };
